import {useNavigate, useSearchParams} from "react-router-dom";
import {serviceEventSelector, useGetServiceEventQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {useTranslation} from "react-i18next";
import {ServiceEventMap} from "../../components/profile/ServiceEventProfile/ServiceEventMap";
import {ProtectedPage} from "../../components/page/ProtectedPage/ProtectedPage";

type Props = {
  id?: string;
  database?: string
}

export const ServiceEventMapPageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const id = params.get("id") ?? undefined;

  const {t} = useTranslation(["common"])

  if (!id) {
    navigate(-1);
    return (
        <ErrorPage
            message={t("common.entity.serviceevent", "Service Event") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ServiceEventMapPage id={id}/>;
};

export const ServiceEventMapPage = (props: Props) => {
  const {id} = props;

  const {t} = useTranslation(["common"])

  const [access, setAccess] = useState(false);

  const selectServiceEvent = useMemo(() => {
    return serviceEventSelector()
  }, []);

  const idQueryArg = useMemo(() => {
    return access ? id : skipToken
  }, [access, id])

  const {serviceEvent, isFetching} = useGetServiceEventQuery(idQueryArg, {
    selectFromResult: (result) => ({
      serviceEvent: selectServiceEvent(result),
      isFetching: result.isFetching
    })
  });

  const error = !serviceEvent ? t<string>("common.error.notfound", "Not Found") : undefined

  return (
      <ProtectedPage
          permissions={["serviceevent_view"]}
          isLoading={isFetching}
          error={error}
          onAccess={setAccess}>
        <ServiceEventMap serviceEvent={serviceEvent}/>
      </ProtectedPage>
  );
};
